import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
	  padding: 0;
	  margin: 0;
    font-size: 14px;
    
    @media (max-height: 800px) {
      font-size: 12px;
      h1 {
        font-size: 2.5rem;
      }
      h2 {
        font-size: 2rem;
      }
      h3 {
        font-size: 1.75rem;
      }
      h4 {
        font-size: 1.25rem;
      }
      h5{
        font-size: 1rem
      }
  }
    @media (max-width: 1400px) {
      font-size: 12px;
  }
  }
  
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue';
    background: ${({ theme }: any) => theme.background};
    color: ${({ theme }) => theme.fontColor};
  }

  p{
    margin: 0;
  }
`;

export default GlobalStyles;
